import { removeEspace } from './string.utils';

const EVERY_FOUR_CHARS = /(.{4})(?!$)/g;

export function formatIban(iban: string, separator = ' '): string {
    return removeEspace(iban).replace(EVERY_FOUR_CHARS, '$1' + separator);
}

export const countryMap = {
    "AF": "Afghanistan (l')",
    "AX": "Åland (les Îles)",
    "AL": "Albanie (l')",
    "DZ": "Algérie (l')",
    "AS": "Samoa américaines (les)",
    "AD": "Andorre (l')",
    "AO": "Angola (l')",
    "AI": "Anguilla",
    "AQ": "Antarctique (l')",
    "AG": "Antigua-et-Barbuda",
    "AR": "Argentine (l')",
    "AM": "Arménie (l')",
    "AW": "Aruba",
    "AU": "Australie (l')",
    "AT": "Autriche (l')",
    "AZ": "Azerbaïdjan (l')",
    "BS": "Bahamas (les)",
    "BH": "Bahreïn",
    "BD": "Bangladesh (le)",
    "BB": "Barbade (la)",
    "BY": "Bélarus (le)",
    "BE": "Belgique (la)",
    "BZ": "Belize (le)",
    "BJ": "Bénin (le)",
    "BM": "Bermudes (les)",
    "BT": "Bhoutan (le)",
    "BO": "Bolivie (État plurinational de)",
    "BQ": "Bonaire, Saint-Eustache et Saba",
    "BA": "Bosnie-Herzégovine (la)",
    "BW": "Botswana (le)",
    "BV": "Bouvet (l'Île)",
    "BR": "Brésil (le)",
    "IO": "Indien (le Territoire britannique de l'océan)",
    "BN": "Brunéi Darussalam (le)",
    "BG": "Bulgarie (la)",
    "BF": "Burkina Faso (le)",
    "BI": "Burundi (le)",
    "CV": "Cap-Vert",
    "KH": "Cambodge (le)",
    "CM": "Cameroun (le)",
    "CA": "Canada (le)",
    "KY": "Caïmans (les Îles)",
    "CF": "République centrafricaine (la)",
    "TD": "Tchad (le)",
    "CL": "Chili (le)",
    "CN": "Chine (la)",
    "CX": "Christmas (l'Île)",
    "CC": "Cocos (les Îles)/ Keeling (les Îles)",
    "CO": "Colombie (la)",
    "KM": "Comores (les)",
    "CD": "Congo (la République démocratique du)",
    "CG": "Congo (le)",
    "CK": "Cook (les Îles)",
    "CR": "Costa Rica (le)",
    "HR": "Croatie (la)",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Chypre",
    "CZ": "Tchéquie (la)",
    "DK": "Danemark (le)",
    "DJ": "Djibouti",
    "DM": "Dominique (la)",
    "DO": "dominicaine (la République)",
    "EC": "Équateur (l')",
    "EG": "Égypte (l')",
    "SV": "El Salvador",
    "GQ": "Guinée équatoriale (la)",
    "ER": "Érythrée (l')",
    "EE": "Estonie (l')",
    "SZ": "Eswatini (l')",
    "ET": "Éthiopie (l')",
    "FK": "Falkland (les Îles)/Malouines (les Îles)",
    "FO": "Féroé (les Îles)",
    "FJ": "Fidji (les)",
    "FI": "Finlande (la)",
    "FR": "France (la)",
    "GF": "Guyane française (la)",
    "PF": "Polynésie française (la)",
    "TF": "Terres australes françaises (les)",
    "GA": "Gabon (le)",
    "GM": "Gambie (la)",
    "GE": "Géorgie (la)",
    "DE": "Allemagne (l')",
    "GH": "Ghana (le)",
    "GI": "Gibraltar",
    "GR": "Grèce (la)",
    "GL": "Groenland (le)",
    "GD": "Grenade (la)",
    "GP": "Guadeloupe (la)",
    "GU": "Guam",
    "GT": "Guatemala (le)",
    "GG": "Guernesey",
    "GN": "Guinée (la)",
    "GW": "Guinée-Bissau (la)",
    "GY": "Guyana (le)",
    "HT": "Haïti",
    "HM": "Heard-et-Îles MacDonald (l'Île)",
    "VA": "Saint-Siège (le)",
    "HN": "Honduras (le)",
    "HK": "Hong Kong",
    "HU": "Hongrie (la)",
    "IS": "Islande (l')",
    "IN": "Inde (l')",
    "ID": "Indonésie (l')",
    "IR": "Iran (République Islamique d')",
    "IQ": "Iraq (l')",
    "IE": "Irlande (l')",
    "IM": "Île de Man",
    "IL": "Israël",
    "IT": "Italie (l')",
    "CI": "Côte d'Ivoire (la)",
    "JM": "Jamaïque (la)",
    "JP": "Japon (le)",
    "JE": "Jersey",
    "JO": "Jordanie (la)",
    "KZ": "Kazakhstan (le)",
    "KE": "Kenya (le)",
    "KI": "Kiribati",
    "KP": "Corée (la République populaire démocratique de)",
    "KR": "Corée (la République de)",
    "KW": "Koweït (le)",
    "KG": "Kirghizistan (le)",
    "LA": "Lao (la République démocratique populaire)",
    "LV": "Lettonie (la)",
    "LB": "Liban (le)",
    "LS": "Lesotho (le)",
    "LR": "Libéria (le)",
    "LY": "Libye (la)",
    "LI": "Liechtenstein (le)",
    "LT": "Lituanie (la)",
    "LU": "Luxembourg (le)",
    "MO": "Macao",
    "MG": "Madagascar",
    "MW": "Malawi (le)",
    "MY": "Malaisie (la)",
    "MV": "Maldives (les)",
    "ML": "Mali (le)",
    "MT": "Malte",
    "MH": "Marshall (les Îles)",
    "MQ": "Martinique (la)",
    "MR": "Mauritanie (la)",
    "MU": "Maurice",
    "YT": "Mayotte",
    "MX": "Mexique (le)",
    "FM": "Micronésie (États fédérés de)",
    "MD": "Moldova (la République de)",
    "MC": "Monaco",
    "MN": "Mongolie (la)",
    "ME": "Monténégro (le)",
    "MS": "Montserrat",
    "MA": "Maroc (le)",
    "MZ": "Mozambique (le)",
    "MM": "Myanmar (le)",
    "NA": "Namibie (la)",
    "NR": "Nauru",
    "NP": "Népal (le)",
    "NL": "Pays-Bas (les)",
    "NC": "Nouvelle-Calédonie (la)",
    "NZ": "Nouvelle-Zélande (la)",
    "NI": "Nicaragua (le)",
    "NE": "Niger (le)",
    "NG": "Nigéria (le)",
    "NU": "Niue",
    "NF": "Norfolk (l'Île)",
    "MK": "Macédoine du Nord (la)",
    "MP": "Mariannes du Nord (les Îles)",
    "NO": "Norvège (la)",
    "OM": "Oman",
    "PK": "Pakistan (le)",
    "PW": "Palaos (les)",
    "PS": "Palestine, État de",
    "PA": "Panama (le)",
    "PG": "Papouasie-Nouvelle-Guinée (la)",
    "PY": "Paraguay (le)",
    "PE": "Pérou (le)",
    "PH": "Philippines (les)",
    "PN": "Pitcairn",
    "PL": "Pologne (la)",
    "PT": "Portugal (le)",
    "PR": "Porto Rico",
    "QA": "Qatar (le)",
    "RE": "Réunion (La)",
    "RO": "Roumanie (la)",
    "RU": "Russie (la Fédération de)",
    "RW": "Rwanda (le)",
    "BL": "Saint-Barthélemy",
    "SH": "Sainte-Hélène, Ascension et Tristan da Cunha",
    "KN": "Saint-Kitts-et-Nevis",
    "LC": "Sainte-Lucie",
    "MF": "Saint-Martin (partie française)",
    "PM": "Saint-Pierre-et-Miquelon",
    "VC": "Saint-Vincent-et-les Grenadines",
    "WS": "Samoa (le)",
    "SM": "Saint-Marin",
    "ST": "Sao Tomé-et-Principe",
    "SA": "Arabie saoudite (l')",
    "SN": "Sénégal (le)",
    "RS": "Serbie (la)",
    "SC": "Seychelles (les)",
    "SL": "Sierra Leone (la)",
    "SG": "Singapour",
    "SX": "Saint-Martin (partie néerlandaise)",
    "SK": "Slovaquie (la)",
    "SI": "Slovénie (la)",
    "SB": "Salomon (les Îles)",
    "SO": "Somalie (la)",
    "ZA": "Afrique du Sud (l')",
    "GS": "Géorgie du Sud-et-les Îles Sandwich du Sud (la)",
    "SS": "Soudan du Sud (le)",
    "ES": "Espagne (l')",
    "LK": "Sri Lanka",
    "SD": "Soudan (le)",
    "SR": "Suriname (le)",
    "SJ": "Svalbard et l'Île Jan Mayen (le)",
    "SE": "Suède (la)",
    "CH": "Suisse (la)",
    "SY": "République arabe syrienne (la)",
    "TW": "Taïwan (Province de Chine)",
    "TJ": "Tadjikistan (le)",
    "TZ": "Tanzanie (la République-Unie de)",
    "TH": "Thaïlande (la)",
    "TL": "Timor-Leste (le)",
    "TG": "Togo (le)",
    "TK": "Tokelau (les)",
    "TO": "Tonga (les)",
    "TT": "Trinité-et-Tobago (la)",
    "TN": "Tunisie (la)",
    "TR": "Turquie (la)",
    "TM": "Turkménistan (le)",
    "TC": "Turks-et-Caïcos (les Îles)",
    "TV": "Tuvalu (les)",
    "UG": "Ouganda (l')",
    "UA": "Ukraine (l')",
    "AE": "Émirats arabes unis (les)",
    "GB": "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord (le)",
    "UM": "Îles mineures éloignées des États-Unis (les)",
    "US": "États-Unis d'Amérique (les)",
    "UY": "Uruguay (l')",
    "UZ": "Ouzbékistan (l')",
    "VU": "Vanuatu (le)",
    "VE": "Venezuela (République bolivarienne du)",
    "VN": "Viet Nam (le)",
    "VG": "Vierges britanniques (les Îles)",
    "VI": "Vierges des États-Unis (les Îles)",
    "WF": "Wallis-et-Futuna",
    "EH": "Sahara occidental (le)*",
    "YE": "Yémen (le)",
    "ZM": "Zambie (la)",
    "ZW": "Zimbabwe (le)"
};

export const BIC_MIN_LENGTH = 8;
export const BIC_MAX_LENGTH = 11;
export const IBAN_ACCOUNT_OWNER_MAX_LENGTH = 140;
export const IBAN_ACCOUNT_OWNER_ADDRESS_LINE_MAX_LENGTH = 70;
export const IBAN_ACCOUNT_OWNER_TOWN_MAX_LENGTH = 35;
export const IBAN_ACCOUNT_OWNER_POST_CODE_MAX_LENGTH = 16;
export const IBAN_ACCOUNT_OWNER_COUNTRY_CODE_MAX_LENGTH = 2;
export const IBAN_ACCOUNT_OWNER_DEFAULT_COUNTRY_CODE = 'FR';
